import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Steps } from './components/Steps';
import { Products } from './components/Products';
import { Packs } from './components/Packs';
import { Benefits } from './components/Benefits';
import { ProofGallery } from './components/ProofGallery';
import { BeforeOrdering } from './components/BeforeOrdering';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyMobileCta } from './components/StickyMobileCta';
import { useContentProtection } from './hooks/useContentProtection';
export function App() {
  useContentProtection();
  return <div className="min-h-screen w-full bg-cream font-sans text-night-900" data-id="element-0" data-mp="31cjk5p91r2w3">
      <Navbar data-id="element-1" data-mp="2wip6p3k1bk5g" />
      <main data-id="element-2" data-mp="2wi5lndz38fn7">
        <Hero data-id="element-3" data-mp="28ufm24yk52fw" />
        <Steps data-id="element-4" data-mp="28tw44o8wqe1v" />
        <Products data-id="element-5" data-mp="28te2td7e19n3" />
        <Packs data-id="element-6" data-mp="28suvsrja05nu" />
        <Benefits data-id="element-7" data-mp="28sbbx5a2f776" />
        <ProofGallery data-id="element-8" data-mp="23vchelmhoy8g" />
        <BeforeOrdering data-id="element-9" data-mp="23vulg4fe8gqx" />
        <Faq data-id="element-10" data-mp="23ujlkfp2jt53" />
        <FinalCta data-id="element-11" data-mp="23v2s7099qv3t" />
      </main>
      <footer className="border-t border-white/10 bg-night-900 px-4 pb-20 pt-6 text-center text-xs text-white/50 sm:px-6 md:pb-6" data-id="element-12" data-mp="3ijxo6nd1puib">
        © 2026 Blue &amp; White · Empanadas Argentinas Premium · Costa Rica
      </footer>
      <StickyMobileCta data-id="element-13" data-mp="3rbrcivytg9ig" />
    </div>;
}